/**
 * Curated section wrapper (Features 083 + 096)
 * Renders the gold "CURATED BY BQUEST" eyebrow, a heading, a subtitle, and its
 * children inside a tinted panel. Shared by the care-seeker My Team sections
 * and the professional-surface curated panels.
 */

import { Sparkles } from 'lucide-react';
import type { ReactNode } from 'react';

type CuratedSectionProps = {
  title: string;
  subtitle: string;
  children: ReactNode;
};

export function CuratedSection({ title, subtitle, children }: CuratedSectionProps) {
  return (
    <section className="mt-8 rounded-xl border border-[#e7dcc4] bg-[#faf6ee] p-6">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles className="w-4 h-4 text-[#a67c1a]" aria-hidden="true" />
        <span className="text-xs font-semibold uppercase tracking-wider text-[#a67c1a]">
          Curated by bQuest
        </span>
      </div>
      <h2 className="text-2xl text-gray-900 mb-1">{title}</h2>
      <p className="text-sm text-gray-600 mb-5">{subtitle}</p>
      {children}
    </section>
  );
}
